<form [formGroup]="form">
  <div fxLayout="row" fxLayoutGap="20px">
    <div fxFlex fxLayout="column" fxLayoutAlign="start">
      @if (strategyType == 'Stamps') {
        <div class="section-title">Stamps settings</div>
        <div class="box space-bottom" fxLayout="column" fxLayoutAlign="start">
          <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
            @if (!allowFlow) {
              <mat-form-field fxFlex>
                <mat-label>Stamps to complete</mat-label>
                <input type="number" matInput placeholder=""
                  formControlName="maxStampCount" step="1" autocomplete="off">
                @if (!form.get('maxStampCount').valid) {
                  <mat-error>Please enter a valid number of stamps to
                    complete
                    the
                  card</mat-error>
                }
              </mat-form-field>
            }
          </div>
        </div>
      }
      @if (strategyType == 'Stamps') {
        <div class="box space-top" fxLayout="column"  [style.marginTop.px]="20" fxLayoutAlign="start">
          <h5 class="section-title">Card Restart Limit</h5>
          <div fxLayout="row">
            <mat-form-field fxFlex>
              <mat-label>Limit number of completes</mat-label>
              <input matInput type="number" placeholder=""
                formControlName="restartLimit" maxlength="100" autocomplete="off" step="1">
              @if (!form.get('restartLimit').valid) {
                <mat-error>Please enter the max no of
                completes</mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      }
    </div>

    @if (!allowFlow && strategyType =='Stamps') {
      <div fxFlex fxLayout="column" fxLayoutAlign="start">
        <div class="section-title">Complete Reward</div>
        <div class="box" fxLayout="column" fxLayoutAlign="start">
          <div fxLayout="row" fxLayoutAlign="space-between center">
            <mat-form-field fxFlex>
              <mat-label>Reward product</mat-label>
              <mat-select [compareWith]="compareProductRewardFn"
                (selectionChange)="onRewardSelected($event.value)" placeholder=""
                formControlName="productReward">
                <mat-option [value]="null"></mat-option>
                @for (product of rewardProductsOptions; track product) {
                  <mat-option [value]="product"
                  [matTooltip]="product.productSlug">{{ product.rewardTitle }}</mat-option>
                }
              </mat-select>
              @if (!form.get('productReward').valid) {
                <mat-error>Please select a reward</mat-error>
              }
            </mat-form-field>
            <div fxFlex="40px">
              @if (!form.value.productReward) {
                <lib-button variant="icon" icon="add_circle" color="primary" (buttonClick)="onAddRewardProduct()" tooltip="Add reward product"></lib-button>
              }
              @if (form.value.productReward) {
                <lib-button variant="icon" icon="delete" color="primary" (buttonClick)="onRemoveRewardProduct()" tooltip="Delete reward product"></lib-button>}
            </div>
          </div>
          <div fxFlex fxLayout="row" fxLayoutGap="20px">
            @if (form.value?.productReward?.rewardPhotoUrl) {
              <div class="avatar">
                <lib-photo [url]="form.value?.productReward?.rewardPhotoUrl" [width]="'153px'"
                [height]="'153px'" [radius]="'10px'"></lib-photo>
              </div>
            }
            <div fxFlex fxLayout="column" fxLayoutAlign="start">
              @if (form?.value?.productReward?.rewardTitle) {
                <div class="info-v">
                  <div class="lbl">Reward title</div>
                  <div class="val" [innerHTML]="form.value.rewardTitle"></div>
                </div>
              }
              @if (form?.value?.productReward?.rewardDescription) {
                <div class="info-v">
                  <div class="lbl">Reward description</div>
                  <div class="val" [innerHTML]="form.value.rewardDescription"></div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    }
  </div>


</form>